<script lang="ts">
  import type { SurfaceTask } from "./types";

  let { task }: { task: SurfaceTask } = $props();

  const isVault = $derived(
    !!task.project_slug && !task.project_slug.startsWith("_") && !task.fingerprint.startsWith("gt:"),
  );
</script>

<span class="badges" aria-hidden="true">
  {#if isVault}
    <span class="src-pill vault" title="Vault-backed">
      <svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true">
        <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v9A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V6.2a1.5 1.5 0 0 0-.44-1.06L10.86 2.44A1.5 1.5 0 0 0 9.8 2H3.5Zm.5 1h5v3a1 1 0 0 0 1 1h3v5.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5Zm6 0.2L12.8 6H10.5a.5.5 0 0 1-.5-.5V3.2Z" fill="currentColor"/>
      </svg>
    </span>
  {/if}
  {#if task.account === "personal"}
    <span class="src-dot personal" title="Personal"></span>
  {:else if task.account === "work"}
    <span class="src-dot work" title="Work"></span>
  {/if}
</span>

<style>
  .badges {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }
  .src-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    border-radius: 5px;
    background: var(--bg-elev-2);
    color: var(--fg-dim);
  }
  .src-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
  }
  .src-dot.personal { background: var(--domain-business); }
  .src-dot.work     { background: var(--domain-growth); }
</style>
